import {Provider} from '@angular/core';

import {ListDocumentTypesUseCase} from '@features/setting/application/use_cases/list-document-types/list-document-types.use-case';

import {
  ListDocumentTypesHttpProvider
} from '@features/setting/infrastructure/http/list-document-types/list-document-types.http.provider';

export const ListDocumentTypesUseCaseProvider: Provider[] = [
  ...ListDocumentTypesHttpProvider,
  ListDocumentTypesUseCase
];
